import React from "react"
import LoadMore from "@/components/cart/Pagination/LoadMore"
import Pagination from "@/components/cart/Pagination/Pagination"
import styles from "./index.module.scss"

const CartPagination = props => {
  return (
    <div className={styles.CartPaginationWrapper}>
      <LoadMore {...props} />
      <Pagination {...props} />
    </div>
  )
}

export default CartPagination
